import { useMqtt } from '../providers/MqttClientProvider';
import { useAuth } from '@presov.sk/presov-auth-react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

const FrontChannelLogoutPage: React.FC = () => {
  const { clearStorage } = useAuth();
  const { disconnect } = useMqtt();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    clearStorage();
    disconnect?.();
  }, [searchParams, disconnect, clearStorage]);

  return null; // nič netreba zobrazovať v iframe
};

export default FrontChannelLogoutPage;
